import * as React from 'react';
import { useSelector } from 'react-redux';

import { TextMessage } from '../../../../components/TextMessage';
import { currentOpenChatIDSelector } from '../../../../selectors';
import { TMessage, TOutcomingStatus } from '../../../../types/messages';
import { useMessageText, useMessageHtmlText } from '../../hooks';
import { trackClickMessage } from '../../tracking';

interface ITextMessageContainerProps {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
  htmlText?: string;
}

export const TextMessageContainer: React.FC<ITextMessageContainerProps> = ({ message, messageId }) => {
  const { isOutcoming, communicationId, offers } = message;

  const offer = offers?.[0];

  const htmlText = useMessageHtmlText(message);

  const text = useMessageText({ message, messageId });

  const chatId = useSelector(currentOpenChatIDSelector) || '';

  const onClickMessage = React.useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      if ((e.target as HTMLElement).tagName === 'A') {
        const anchor = e.target as HTMLAnchorElement;
        const messageType = anchor.href.includes('tel') ? 'phone' : 'link';
        const clickText = anchor.dataset.clickText;

        trackClickMessage({
          chatId,
          messageId,
          messageType,
          offerId: offer?.realtyOfferId,
          communicationId,
          clickText,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chatId, offer],
  );

  if (!htmlText && !text) {
    return null;
  }

  return (
    <TextMessage
      // eslint-disable-next-line react/no-danger
      text={htmlText ? <div dangerouslySetInnerHTML={{ __html: htmlText }} /> : text}
      onClick={onClickMessage}
      textColor={isOutcoming ? 'text-inverted-default' : 'text-primary-default'}
    />
  );
};
